export default __webpack_public_path__ + "57bed1b9b9b6cfd5220c1ee2afe6fe2e.jpg";